module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"eco-friendly":"Eco-Friendly","home":"Home","interventi":"Method","progetto":"Project","servizi":"Services","sicurezza":"Security","trasparenza":"Transparency"},"it":{"eco-friendly":"Eco-Friendly","home":"Home","interventi":"Modalità","progetto":"Progetto","servizi":"Servizi","sicurezza":"Sicurezza","trasparenza":"Trasparenza"}}')
  delete Component.options._Ctor
}
